/** @format */

export enum FavoritesLocationEnum {
	BUNDLE = 'BUNDLE',
	FAVORITES = 'Favorites',
	PDP = 'PDP',
	PLP = 'PLP',
	QuickView = 'QV',
	RECOMMENDED = 'RECOMMENDED',
	FBT = 'FBT'
}
